import { render, staticRenderFns } from "./loanyx.vue?vue&type=template&id=53ae0550&"
import script from "./loanyx.vue?vue&type=script&lang=js&"
export * from "./loanyx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports